export const WellsViewSVG = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-6 w-6"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth="2"
    >
        <title>WellsView</title>
        <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
        />
    </svg>
);

export const MiningAndPumpingSVG = props => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
        <title>MiningAndPumping</title>
        <path fill="none" strokeWidth={2} strokeLinecap="round" d="M14.414 3L19 7.586M14 7.586L18.586 3" />
        <path
            d="M6 21l-.992-.124L4.868 22H6v-1zM7.781 6.752l.992.124-.992-.124zM18 21v1h1.138l-.146-1.128L18 21zm-.32-10.262a1 1 0 10-1.984.257l1.983-.257zM11 6a1 1 0 100-2v2zM6.992 21.124L8.773 6.876 6.79 6.628 5.008 20.876l1.984.248zM18 20h-6v2h6v-2zm-6 0H6v2h6v-2zm3.696-9.005l1.312 10.133 1.984-.256-1.313-10.134-1.983.257zM9.766 6H11V4H9.766v2zm-.993.876A1 1 0 019.766 6V4a3 3 0 00-2.977 2.628l1.984.248z"
            stroke="none"
        />
        <path d="M4 20a1 1 0 100 2v-2zm16 2a1 1 0 100-2v2zM4 22h16v-2H4v2z" stroke="none" />
        <path d="M15.812 10.274l-9.5 9 1.376 1.452 9.5-9-1.376-1.452z" stroke="none" />
        <path
            d="M8.707 10.293a1 1 0 10-1.414 1.414l1.414-1.414zm-1.414 1.414l9 9 1.414-1.414-9-9-1.414 1.414z"
            stroke="none"
        />
    </svg>
);

export const TechnologicalEfficiencyGTMSVG = props => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
        <title>TechnologicalEfficiencyGTM</title>
        <rect fill="none" x={3} y={5} width={18} height={16} rx={3} strokeWidth={2} />
        <path fill="none" strokeWidth={2} strokeLinejoin="round" d="M7 11h5v5H7z" />
        <path fill="none" strokeWidth={2} strokeLinecap="round" d="M8 7V3M16 7V3" />
    </svg>
);

export const GsrSVG = props => {
    return (
        <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <title>Gsr</title>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6 2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4Zm0 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H6Z"
                strokeWidth={0.1}
            />
            <path
                d="M6 8a1 1 0 0 1 1-1h7a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1ZM6 12a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1ZM6 16a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Z"
                strokeWidth={0.1}
            />
        </svg>
    );
};

export const WellLoggingOperationsSVG = props => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
        <title>WellLoggingOperations</title>
        <path d="M7 20a1 1 0 11-2 0h2zM5 4a1 1 0 012 0H5zm0 16V4h2v16H5z" stroke="none" />
        <path fill="none" strokeWidth={2} strokeLinecap="round" d="M7 6h1M7 14h1M7 10h2M7 18h2" />
        <path
            stroke="none"
            d="M18.707 5.707a1 1 0 00-1.414-1.414l1.414 1.414zM15 8l-.707-.707a1 1 0 000 1.414L15 8zm3 3l.707.707a1 1 0 000-1.414L18 11zm-4 4l-.707-.707a1 1 0 00-.074 1.332L14 15zm3.22 5.625a1 1 0 101.56-1.25l-1.56 1.25zm.073-16.332l-3 3 1.414 1.414 3-3-1.414-1.414zm-3 4.414l3 3 1.414-1.414-3-3-1.414 1.414zm3 1.586l-4 4 1.414 1.414 4-4-1.414-1.414zm-4.074 5.332l4 5 1.562-1.25-4-5-1.562 1.25z"
        />
    </svg>
);

export const MapSVG = props => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
        <title>Map</title>
        <rect x={3} y={3} width={18} height={18} rx={3} fill="none" strokeWidth={2} />
        <path
            d="M3.986 5.836a1 1 0 10-1.972.328l1.972-.328zm-1.972.328c.266 1.6.732 3.166 2.22 4.603 1.44 1.39 3.748 2.572 7.479 3.69l.574-1.915c-3.628-1.088-5.57-2.157-6.664-3.214C4.575 8.316 4.22 7.237 3.986 5.836l-1.972.328zm9.699 8.294c2.24.672 3.213 1.843 3.593 2.933.398 1.147.197 2.367-.2 3.162l1.788.894c.603-1.205.902-2.985.3-4.713-.62-1.785-2.147-3.364-4.907-4.192l-.574 1.916zM7.986 2.836a1 1 0 10-1.972.328l1.972-.328zm-1.972.328c.266 1.6.732 3.166 2.22 4.602 1.44 1.391 3.748 2.573 7.479 3.692l.574-1.916c-3.628-1.088-5.57-2.157-6.664-3.214C8.575 5.316 8.22 4.237 7.986 2.836l-1.972.328zm9.699 8.294c2.266.68 3.264 1.757 3.752 2.83C19.986 15.438 20 16.72 20 18h2c0-1.22.014-2.937-.715-4.539-.762-1.676-2.264-3.099-4.998-3.919l-.574 1.916z"
            stroke="none"
        />
        <path
            d="M12 2.5c1 5 6.567 5.833 5.5.5M6.5 21c-.5-1.167 0-4.5 2.5-4.5s3.166 3 4 4.5"
            fill="none"
            strokeWidth={2}
        />
    </svg>
);

export const OilProductionLossSVG = props => (
    <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <title>OilProductionLoss</title>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20 14c0 5-3.582 8-8 8s-8-3-8-8C4 9.582 9 2 12 2s8 8 8 12Zm-2.009-.006c.006-.13.009-.261.009-.394 0-3.2-3.75-9.6-6-9.6s-6 6.065-6 9.6c0 .138.003.273.01.407 1.172.833 3.995 1.988 5.99-.007 1.995-1.995 4.82-.84 5.991-.006Z"
            strokeWidth={0.1}
        />
    </svg>
);

export const FactorAnalysisSVG = props => {
    return (
        <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <title>FactorAnalysis</title>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18 2H6a4 4 0 0 0-4 4v6.204l2-1.579V10h.792l2.35-1.855c.064-.051.131-.1.2-.145H4V6a2 2 0 0 1 2-2h2v3.671a3.006 3.006 0 0 1 2 0V4h4v4h-3.341c.09.06.177.125.262.195L13.086 10H14v.761l.816.68L16 10.258V10h.257l2-2H16V4h2a2 2 0 0 1 2 2v.257l1.723-1.723A4.001 4.001 0 0 0 18 2Zm4 10.743L18.743 16H20v2a2 2 0 0 1-2 2h-2v-1.671a3.008 3.008 0 0 1-2 0V20h-4v-4h.914l-1.965-1.637L6.875 16H8v4H6a2 2 0 0 1-1.984-1.743l-1.688 1.332A4.001 4.001 0 0 0 6 22h12a4 4 0 0 0 4-4v-5.257Z"
                strokeWidth={0.1}
            />
            <g clipPath="url(#a)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="m25.707 6.207-10 10a1 1 0 0 1-1.347.061l-5.377-4.48L.12 18.785l-1.24-1.57 9.5-7.5a1 1 0 0 1 1.26.017l5.299 4.415 9.354-9.354 1.414 1.414Z"
                    strokeWidth={0.1}
                />
            </g>
            <defs>
                <clipPath id="a">
                    <path transform="translate(2 2)" d="M0 0h20v20H0z" />
                </clipPath>
            </defs>
        </svg>
    );
};

export const DesaturationCharacteristicsSVG = props => (
    <svg width={20} height={18} viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <title>DesaturationCharacteristics</title>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.293 10.293a1 1 0 011.414 0L16 12.586l2.293-2.293a1 1 0 111.414 1.414L17.414 14l2.293 2.293a1 1 0 01-1.414 1.414L16 15.414l-2.293 2.293a1 1 0 01-1.414-1.414L14.586 14l-2.293-2.293a1 1 0 010-1.414z"
            strokeWidth={0.1}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.162.73a1 1 0 01.963-.73H19a1 1 0 110 2h-7.117L7.588 17.27a1 1 0 01-1.86.172l-3.1-6.3H1a1 1 0 010-2h2.25a1 1 0 01.897.56l2.222 4.514L10.162.729z"
            strokeWidth={0.1}
        />
    </svg>
);

export const Checkbox = props => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <title>Checkbox</title>
        <path d="M12.5 5L7 11 4 8" fill="none" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export const OptionsSVG = props => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
        <title>Options</title>
        <path
            d="M14 5a2 2 0 11-4 0 2 2 0 014 0zM14 12a2 2 0 11-4 0 2 2 0 014 0zM14 19a2 2 0 11-4 0 2 2 0 014 0z"
            stroke="none"
        />
    </svg>
);

export const Pin = props => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <title>Pin</title>
        <g clipPath="url(#prefix__clip0)" strokeWidth={1.4}>
            <path d="M9.877 1.786h-.003.003zm0 0l.005.001h-.005zm.566.437l3.084 3.084a.9.9 0 00-.162.128L9.673 9.127a.9.9 0 00-.247.466l-.333 1.73-.149.15-4.667-4.668.149-.148 1.73-.333-.132-.688.132.688a.9.9 0 00.467-.248l3.692-3.691a.902.902 0 00.128-.162zM6.823 8.927L1.52 14.23" />
        </g>
        <defs>
            <clipPath id="prefix__clip0">
                <path fill="#fff" d="M0 0h16v16H0z" />
            </clipPath>
        </defs>
    </svg>
);

export const ReportsSVG = props => (
    <svg width={16} height={16} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <title>Reports</title>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.7 1.6H3.3A2.7 2.7 0 00.6 4.3v5.4c0 1.213.8 2.239 1.9 2.58v-1.555A1.298 1.298 0 012 9.7V4.3A1.3 1.3 0 013.3 3h9.4A1.3 1.3 0 0114 4.3v5.4c0 .416-.196.787-.5 1.025v1.555a2.701 2.701 0 001.9-2.58V4.3a2.7 2.7 0 00-2.7-2.7z"
            fill="#FFC107"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4 9.667a1 1 0 011 1V13a1 1 0 01-2 0v-2.333a1 1 0 011-1zM6.667 7a1 1 0 011 1v5a1 1 0 11-2 0V8a1 1 0 011-1zM12 5.5a1 1 0 011 1V13a1 1 0 11-2 0V6.5a1 1 0 011-1zM9.333 8.333a1 1 0 011 1V13a1 1 0 11-2 0V9.333a1 1 0 011-1z"
            fill="#FFC107"
        />
    </svg>
);

export const CloseSvg = props => (
    <svg width={12} height={12} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <title>Close</title>
        <path transform="matrix(.72083 .6931 -.72083 .6931 1 2)" strokeWidth={2} d="M0-1h12.985" />
        <path transform="matrix(-.72083 .6931 .72083 .6931 11.5 2)" strokeWidth={2} d="M0-1h12.985" />
    </svg>
);

export const UrzmSVG = props => (
    <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <title>Urzm</title>
        <circle cx={3} cy={8} r={2} stroke="currentColor" />
        <circle cx={13} cy={3} r={2} stroke="currentColor" />
        <circle cx={3} cy={16} r={2} stroke="currentColor" />
        <circle cx={13} cy={9} r={2} stroke="currentColor" />
        <circle cx={13} cy={15} r={2} stroke="currentColor" />
        <circle cx={13} cy={21} r={2} stroke="currentColor" />
        <circle cx={21} cy={12} r={2} stroke="currentColor" />
        <path
            d="m3 8 10-5M3 8l10 1M3 8l10 7M3 8l10 13M3 16l10 5M3 16l10-1M3 16l10-7M3 16 13 3M13 3l8 9M13 9l8 3M13 15l8-3M13 21l8-9"
            stroke="currentColor"
        />
    </svg>
);
export const GeoLayers = props => (
    <svg
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="24.000000"
        height="24.000000"
        fill="none"
        customframe="url(#clipPath_0)"
        {...props}
    >
        <defs>
            <clipPath id="clipPath_0">
                <rect
                    width="24.000000"
                    height="24.000000"
                    x="0.000000"
                    y="0.000000"
                    rx="4.000000"
                    fill="rgb(255,255,255)"
                />
            </clipPath>
        </defs>
        <path
            id="Union"
            d="M7.99707 9C8.5487 9 8.996 9.44665 8.99707 9.99803L8.99707 10L8.99707 18C8.99707 18.0436 8.99428 18.0866 8.98886 18.1287C8.9857 18.1533 8.98166 18.1776 8.97675 18.2015C8.8835 18.6572 8.48032 19 7.99707 19C7.75859 19 7.5396 18.9165 7.36775 18.7772C7.14161 18.5938 6.99707 18.3138 6.99707 18L6.99707 10C6.99707 9.44772 7.44478 9 7.99707 9ZM5.99707 12.3964L2.48857 10.2913C2.18737 10.1106 2.00307 9.78507 2.00307 9.43381L2.00307 9C2.00307 8.44772 2.45078 8 3.00307 8L4.27685 8C4.27698 7.83838 4.29726 7.67668 4.3377 7.51492L5.33773 3.51492C5.36623 3.4009 5.40405 3.29104 5.45117 3.18532L5.45121 3.18524C5.49481 3.08744 5.54639 2.99319 5.60593 2.9025C5.66496 2.81258 5.73032 2.72844 5.802 2.65009L5.802 2.65008C5.87684 2.56828 5.95857 2.49278 6.04719 2.42359C6.13581 2.35439 6.22888 2.29342 6.32639 2.24065L6.3264 2.24065C6.4198 2.19011 6.51727 2.14711 6.61883 2.11165C6.72125 2.07589 6.82519 2.04872 6.93064 2.03013C7.04466 2.01004 7.16045 2 7.27801 2L8.71639 2C8.83395 2 8.94974 2.01004 9.06375 2.03013L9.06378 2.03014L9.0638 2.03014L9.06382 2.03015L9.06385 2.03015L9.06388 2.03016C9.16929 2.04874 9.27319 2.0759 9.37558 2.11165C9.47713 2.14711 9.5746 2.19011 9.668 2.24064L9.66801 2.24065C9.76552 2.29341 9.85859 2.35439 9.94721 2.42359C10.0358 2.49278 10.1176 2.56828 10.1924 2.65009L10.1924 2.65012L10.1926 2.65029L10.1926 2.65032C10.2642 2.72861 10.3295 2.81267 10.3885 2.9025C10.448 2.99318 10.4996 3.08742 10.5432 3.18521C10.5903 3.29096 10.6282 3.40086 10.6567 3.51492L11.6567 7.51492C11.6971 7.67668 11.7174 7.83838 11.7175 8L21.0031 8C21.5554 8 22.0031 8.44772 22.0031 9L22.0031 13C22.0031 13.5523 21.5554 14 21.0031 14L19.9971 14L19.9971 16.0001L21.003 16.0001C21.563 16.0001 22.003 16.4401 22.003 17.0001C22.003 17.5601 21.563 18.0001 21.003 18.0001L19.9971 18.0001L19.9971 20.0001L21.003 20.0001C21.563 20.0001 22.003 20.4401 22.003 21.0001C22.003 21.5601 21.563 22.0001 21.003 22.0001L18.003 22.0001L17.9851 22C17.8466 21.9992 17.711 21.9846 17.5784 21.9563C17.4558 21.9301 17.3358 21.8921 17.2183 21.8424C17.1023 21.7934 16.9928 21.7346 16.8897 21.666L16.8897 21.666C16.7801 21.5931 16.6778 21.5092 16.5829 21.4142C16.5788 21.4102 16.5748 21.4061 16.5708 21.4021L11.9574 19.0954L7.37438 20.9286C7.23539 20.9842 7.09768 21.0091 6.96125 21.0035C6.82482 20.9978 6.68966 20.9615 6.55577 20.8945L2.55577 18.8945C2.05489 18.6441 1.85812 18.0538 2.10856 17.5529C2.359 17.052 2.94932 16.8553 3.4502 17.1057L6.03669 18.3989C6.01028 18.2688 5.99707 18.1358 5.99707 18L5.99707 16.6152L2.55583 14.8945C2.05495 14.6441 1.85817 14.0538 2.10861 13.5529C2.35905 13.052 2.94937 12.8553 3.45025 13.1057L5.99707 14.3791L5.99707 12.3964ZM7.99707 8L8.93188 8L6.58939 6.75442L6.27799 8L7.99707 8ZM9.99707 17.7255L11.6316 17.0716C11.9096 16.9605 12.1824 16.9718 12.4502 17.1057L15.9971 18.8791L15.9971 17.1152L11.9575 15.0954L9.99707 15.8795L9.99707 17.7255ZM9.99707 13.7255L11.6317 13.0716C11.9096 12.9605 12.1825 12.9718 12.4503 13.1057L15.9971 14.8791L15.9971 12.997L12.4047 11.2008C12.1492 11.0731 11.8513 11.0607 11.5861 11.1668L9.99707 11.8024L9.99707 13.7255ZM16.9971 15.3791L16.9971 20C16.9971 20.5523 17.4448 21 17.9971 21C18.5148 21 18.9407 20.6065 18.9919 20.1022C18.9953 20.0686 18.9971 20.0345 18.9971 20L18.9971 10C18.9971 9.44772 18.5494 9 17.9971 9C17.4448 9 16.9971 9.44772 16.9971 10L16.9971 15.3791ZM6.97938 5.19451L8.83888 4.52567C8.84163 4.52475 8.84439 4.52386 8.84714 4.52299L8.71639 4L7.27801 4L6.97938 5.19451ZM9.09039 5.49593L7.30031 6.09277L9.51667 7.20104L9.09039 5.49593Z"
            fill="currentColor"
            stroke="none"
            fillRule="evenodd"
        />
    </svg>
);
